// extracted by mini-css-extract-plugin
module.exports = {"container":"Headings_container__1WDkE","title":"Headings_title__33Fa1","action":"Headings_action__3B7_t"};